export const EXCMTASKTYPE_CREATE_RESET = 'EXCMTASKTYPE_CREATE_RESET'
export const EXCMTASKTYPE_CREATE_SET_CREATED = 'EXCMTASKTYPE_CREATE_SET_CREATED'
export const EXCMTASKTYPE_CREATE_SET_ERROR = 'EXCMTASKTYPE_CREATE_SET_ERROR'
export const EXCMTASKTYPE_CREATE_SET_VIOLATIONS = 'EXCMTASKTYPE_CREATE_SET_VIOLATIONS'
export const EXCMTASKTYPE_CREATE_TOGGLE_LOADING = 'EXCMTASKTYPE_CREATE_TOGGLE_LOADING'
